<template>
  <div>
    <div class="form">
      <div class="labeled-field">
        <label for="textarea-1">
          Name
          <span v-html="nameLength" />
        </label>
        <input
          id="new-wishlistname"
          v-model="newWishlistName"
          type="text"
          name="wishlistname"
          :disabled="creationDisabled"
          class="form-control form-control-lg"
          placeholder="Neue Wunschliste"
          @input="checkNameLength"
          @keyup.enter="createWishlist()"
        >
      </div>

      <button
        class="btn form-control btn-bkm mb-2"
        :disabled="creationDisabled"
        @click="createWishlist()"
      >
        Anlegen
      </button>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import loadWishlistModule from '../mixins/loadWishlistModule'

export default {
  name: 'BkCreatewishlist',
  mixins: [loadWishlistModule],
  data () {
    return {
      newWishlistName: '',
      nameMaxLength: 30
    }
  },
  mounted () {
    this.addModalFocusListener()
  },
  computed: {
    ...mapState({
      userWishlists: state => state.bkwishlist.userWishlists
    }),
    nameLength () {
      const length = this.nameMaxLength - this.newWishlistName.length
      return length + ' Zeichen übrig'
    },
    creationDisabled () {
      if (!this.isLoggedIn) return true
      if (this.userWishlists.length > 9) return true
      return false
    },
    ...mapGetters([
      'isLoggedIn'
    ])
  },
  methods: {
    addModalFocusListener () {
      $('#new-wishlist-modal').on('shown.bs.modal', function () {
        $('#new-wishlistname').trigger('focus')
      })
    },
    checkNameLength () {
      this.newWishlistName = this.newWishlistName.slice(0, this.nameMaxLength)
    },
    createWishlist () {
      this.$store.dispatch('createWishlist', { name: this.newWishlistName })
      $('#new-wishlist-modal').modal('hide')
      $('#my-wishlists-modal').modal('show')
      this.newWishlistName = ''
    },
    ...mapActions([
      'removeFromBKWishList'
    ])
  }
}
</script>
